module.exports = __webpack_public_path__ + "static/nicole-honeywill-1432804-unsplash-narrow-7a50ebd0b346895865803dad1cde2d7c.jpg";